var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.translations != null && _vm.translations.header != null,
          expression: "translations != null && translations.header != null"
        }
      ],
      staticClass: "d-flex justify-content-between pl-24 align-items-center"
    },
    [
      _c("div", { staticClass: "d-flex align-items-center" }, [
        _c(
          "a",
          {
            staticClass:
              "font-weight-light link home-link mr-32 d-none d-md-inline-block",
            attrs: { href: _vm.route("nl.home") }
          },
          [_c("strong", [_vm._v("InspireYourTribe")]), _vm._v(".be\n        ")]
        ),
        _vm._v(" "),
        _c("h1", { staticClass: "d-md-none d-xl-block" }, [
          _vm._v(_vm._s(_vm.translations.header.title))
        ])
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.showButtons
          ? _c("div", { staticClass: "d-flex align-items-center h-100" }, [
              _c(
                "a",
                {
                  staticClass: "mr-56 d-none d-md-inline-block share",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.showShareModal($event)
                    }
                  }
                },
                [
                  _vm._v(_vm._s(_vm.translations.header.share)),
                  _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.svg("share", "icon")) }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass:
                    "h-100 request-button px-16 py-24 bg-accent d-none d-md-flex",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.requestOffer($event)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.translations.header.request_offer))]
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.showButtons
        ? _c(
            "div",
            {
              staticClass: "share-mobile d-md-none bg-accent h-100",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.showShareModal($event)
                }
              }
            },
            [
              _c("span", {
                domProps: { innerHTML: _vm._s(_vm.svg("share", "icon")) }
              })
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }